export interface StaffDailyHours {
  dailyStartMinute: number;
  dailyEndMinute: number;
}

export const parseDailyHours = (start: string, end: string): StaffDailyHours | null => {
  const toMinutes = (value: string, fallback: number): number => {
    if (!value) return fallback;
    if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(value)) throw new Error('Enter a valid time.');
    const [hours, minutes] = value.split(':').map(Number);
    return hours * 60 + minutes;
  };
  const dailyStartMinute = toMinutes(start, 0);
  const dailyEndMinute = toMinutes(end, 1440);
  if (dailyStartMinute >= dailyEndMinute) throw new Error('Start time must be before end time on the same day.');
  return dailyStartMinute === 0 && dailyEndMinute === 1440 ? null : { dailyStartMinute, dailyEndMinute };
};

export const dailyHoursVariables = (hours: StaffDailyHours | null) => ({
  dailyStartMinute: hours?.dailyStartMinute ?? null,
  dailyEndMinute: hours?.dailyEndMinute ?? null,
});

export const formatDailyHours = (hours: StaffDailyHours | null): string => {
  if (!hours) return 'All day';
  const format = (minute: number) =>
    `${String(Math.floor(minute / 60)).padStart(2, '0')}:${String(minute % 60).padStart(2, '0')}`;
  return `${format(hours.dailyStartMinute)}–${format(hours.dailyEndMinute)}`;
};
